import React, {useEffect, useState} from "react";
import ReactDOM from "react-dom";
import classNames from "classnames";
import {observer} from "mobx-react";
import {DrawerBodyBox} from "./boxes/body/drawer-body.box";
import {DrawerContentBox} from './boxes/content/drawer-content.box';
import {DrawerSpinnerComponent} from "./drawer-spinner.component";
import {withServices} from "../../react-hooks/with-services";
import {ComponentServicesPick} from "../../services/component-services-pick";

export interface RightDrawerComponentProps extends ComponentServicesPick<'device' | 'drawer' | 'dom'> {
  className?: string;
}

const ComponentBody: React.FC<RightDrawerComponentProps> = observer((props) => {
  const rightDrawer = props.drawer.right;
  const [visualViewportHeight, setVisualViewportHeight] = useState<number | null>(null);

  // when keyboard opens (for example on chat) the drawer will resize to the remaining available height
  useEffect(() => {
    // I don't want this effect to be on hibrid because on iOS the resize event does not fire when the keyboard is closed
    if (props.device.hybrid.isHybrid) {
      return;
    }
    if (!window.visualViewport) {
      return;
    }
    const resizeHandler = () => {
      requestAnimationFrame(() => {
        setVisualViewportHeight(window.visualViewport?.height);
      });
    };
    resizeHandler();
    window.visualViewport?.addEventListener("resize", resizeHandler);

    return () => {
      window.visualViewport?.removeEventListener("resize", resizeHandler);
    }
  }, [props.device.hybrid.isHybrid]);

  const renderContent = () => {
    const lastVisibleDrawerItemIndex = rightDrawer.getLastVisibleDrawerItemIndex();
    const isSpinnerVisible = rightDrawer.isSpinnerVisible;
    return rightDrawer.currentContent.map((content, index) => {
      return (
          <DrawerContentBox key={content.id} id={content.id} visible={index === lastVisibleDrawerItemIndex && !isSpinnerVisible}>
            {content.render()}
          </DrawerContentBox>
      )
    });
  }

  const renderSpinner = () => {
    if(rightDrawer.isSpinnerVisible) {
      return (
          <DrawerSpinnerComponent/>
      )
    }

    return null;
  }

  const renderDrawer = () => {
    let zIndex = rightDrawer.getOverlayZIndex();
    let isBlurBackground = rightDrawer.hasBlurBackground;

    return (
        <DrawerBodyBox zIndex={zIndex} isBlurBackground={isBlurBackground} visualViewportHeight={visualViewportHeight} className={classNames(props.className, {
          open: rightDrawer.isOpen
        })} >
          {renderContent()}
          {renderSpinner()}
        </DrawerBodyBox>
    );
  }

  return ReactDOM.createPortal(renderDrawer(), props.dom.body);

})


export const RightDrawerComponent = withServices(ComponentBody, ["device", "drawer", "dom"]);